export default __webpack_public_path__ + "static/media/loafbread.ff8e374e.png";